'use strict';

import Vue from 'vue';

import store from 'client/store';

import member from './member.js'
import participantMain from '../../../lib/participant'

import filter from "lodash/filter";
import find from "lodash/find";
import map from "lodash/map";
import toUpper from "lodash/toUpper";
import trim from "lodash/trim";

export default {

  getParticipation: function(participationId) {
    return find(store.state.participations.items, i => i.id === participationId)
  },

  getParticipant: function(participation) {
    const type = participation.participantType;

    switch (type) {
      case 'clubMember':
        return find(store.state.members.items, i => i.id === participation.participantId)
      case 'group':
        return find(store.state.groups.items, i => i.id === participation.participantId)
      case 'team':
        return find(store.state.teams.items, i => i.id === participation.participantId)
    }
  },

  getStatus: function (participation, roundIndex, exerciseTypeId = null) {
    return participantMain.getStatus(participation, roundIndex, exerciseTypeId)
  },

  getParticipationClub: function(participation) {
    const participant = this.getParticipant(participation)
    return this.getClub(participant)
  },

  getClub: function (participant) {
    return find(store.state.clubs.items, club => club.id === participant.clubId)
  },

  getCategory: function(participation) {
    return find(store.state.categories.items, category => {
      return category.id === participation.categoryId;
    });
  },

  getMembers: function(participant, type) {
    switch (type) {
      case 'clubMember':
        return [participant]
      case 'group':
      case 'team': {
        const members = map(participant.members, m => find(store.state.members.items, i => i.id === m.memberId))
        return members.filter(i => {
          if ( i ) return true

          console.log('missing member', participant.name, type)
          return false
        })
      }
    }
  },

  getGroups: function(team) {
    const groups = map(team.groups, m => find(store.state.groups.items, i => i.id === m.groupId))
    return groups.filter(i => {
      if ( i ) return true

      console.log('missing group', team.name)
      return false
    })
  },

  getGroupDisplay: function(participation) {
    const eventDiscipline = store.state.eventDisciplines.items.find(i => i.id === participation.eventDisciplineId)

    if (eventDiscipline.groupDisplay) return eventDiscipline.groupDisplay

    //const discipline = store.state.disciplines.items.find(i => i.id === eventDiscipline.disciplineId)
    const discipline = store.state.eventDiscipline.discipline

    if (discipline.labels.groupDisplay) return discipline.labels.groupDisplay

    return 'members'
  },

  getTeamDisplay: function(participation) {
    const eventDiscipline = store.state.eventDisciplines.items.find(i => i.id === participation.eventDisciplineId)

    if (eventDiscipline.teamDisplay) return eventDiscipline.teamDisplay

    return 'team'
  },

  getAddCountry: function(category) {
    const eventDiscipline = store.state.eventDisciplines.items.find(i => i.id === category.eventDisciplineId)
    return eventDiscipline.clubSymbols === 'flags'
  },

  getParticipantNames: function(participation) {
    const type = participation.participantType;
    const participant = this.getParticipant(participation);
    return this.getPersonNames(participant, type, this.getGroupDisplay(participation))
  },

  getPersonNames: function(participant, type, groupDisplay = 'members') {
    switch (type) {
      case 'clubMember':
        return [member.getName(participant)];
      case 'group': {
        if (groupDisplay === 'group') {
          return [participant.name];
        }
        const members = participant.members;
        return map(members, groupMember => {
          const clubMember = find(store.state.members.items, i => i.id === groupMember.memberId)
          return member.getName(clubMember);
        });
      }
      case 'team': {
        const members = participant.members;
        const names = map(members, teamMember => {
          const clubMember = find(store.state.members.items, i => i.id === teamMember.memberId)
          return member.getName(clubMember)
        })

        if (participant.groups?.length > 0) {
          participant.groups.forEach(teamGroup => {
            const group = find(store.state.groups.items, i => i.id === teamGroup.groupId)
            names.push(group?.name)
          })
        }

        return names
      }
    }
  },

  getName: function(participation) {
    const type = participation.participantType;
    const participant = this.getParticipant(participation);
    if (type === 'clubMember') {
      return member.getName(participant);
    }
    else {
      return toUpper(trim(participant.name));
    }
  },

  getClubName: function(participation, participant, addCountry = false) {
    const club = this.getClub(participant)
    const teamDisplay = this.getTeamDisplay(participation)

    let teamPart = null
    if (participation.participantType === 'team') {
      teamPart = participation
    } else {
      teamPart = this.getTeamParticipation(participation)
    }

    let clubName = club.name
    if (teamPart) {
      const team = this.getParticipant(teamPart)

      switch (teamDisplay) {
        case 'club-team':
          clubName = club.name + ' / ' + team.name
          break
        case 'team':
          clubName = team.name
          break
      }
    }

    if (! teamPart) {
      if (participant.trainingCenter) {
        clubName += ' (' + participant.trainingCenter + ')'
      }
    }

    if (addCountry && club.countryId) {
      clubName += ' (' + club.countryId?.substring(8,11).toUpperCase() + ')'
    }

    return clubName
  },

  getCountry: function(participant) {
    const club = this.getClub(participant)
    return store.state.events.countries.find(c => c.id === club.countryId)
  },

  /** Fetch team participation for the individual participation
   *
   * @param participation
   */
  getTeamParticipation: function(participation) {
    const team = find(store.state.teams.items, team => {
      const member = find(team.members, m => m.memberId === participation.participantId)
      return !! member
    })

    if (! team) return null

    return find(store.state.participations.items, p => p.participantType === 'team' && p.participantId === team.id)
  },

  /** fetch the individual participations for the the team participation
   *
    * @param teamParticipationId
   * @returns {*}
   */
  getTeamParticipations: function(teamParticipationId) {
    const teamParticipation = this.getParticipation(teamParticipationId);
    const team = this.getParticipant(teamParticipation);
    const members = this.getMembers(team, 'team');

    return filter(map(members, member =>
      find(store.state.participations.items, item => item.participantId === member.id)
    ), item => item !== undefined);
  },

  getExerciseOptions: function(participation, roundIndex, exerciseTypeId) {
    const partRound = find(participation.rounds, i => i.roundIndex === roundIndex)

    if (! partRound) {
      return {}
    }

    const exercise = find(partRound.exerciseSelection, item => {
      return item.exerciseTypeId === exerciseTypeId;
    });

    return exercise ? exercise.options : {};
  },

  getExerciseLabel: function(participation, roundIndex, exerciseTypeId) {
    let exerciseName = Vue.i18n.t('exercise.type.' + exerciseTypeId);
    const options = this.getExerciseOptions(participation, roundIndex, exerciseTypeId);

    if (options.exerciseTypeId) {
      exerciseName = Vue.i18n.t('exercise.choice') + ': ' +
        Vue.i18n.t('exercise.type.' + options.exerciseTypeId);
    }
    return exerciseName;
  },
};
